import React from 'react'
import { Spinner } from 'react-bootstrap'

export const Loader = () => {
    return (
        <div style={{ width:"100vw", height:"100vh", padding:"10%" }}>
            <Spinner animation='border' style={{ width:100, height:100, margin:"auto" }} className='mt-5 pt-5' />
        </div>
    )
}
